import { auth, db } from "../../../firebase/firebase-config";

import firebase from "firebase/compat/app";
import { types } from "../types/types";

export const getUserByEmail = async (email) => {
  const hasAccount = await db
    .collection("admins")
    .where("email", "==", email)
    .get();
  return !hasAccount.empty;
};
export const refreshToken = async () => {
  const token = await auth.currentUser.getIdToken(true);

  return token;
};

export const loginUser = (email, password, setFieldError) => {
  return async (dispatch) => {
    dispatch(loginUserStart());
    try {
      // Ensure session is persisted across page reloads
      await auth.setPersistence(firebase.auth.Auth.Persistence.LOCAL);

      // Sign in
      const response = await auth.signInWithEmailAndPassword(email, password);

      // Force-refresh the ID token and grab custom claims
      const idToken = await response.user.getIdToken(true);
      const { claims } = await response.user.getIdTokenResult();
      console.log(claims);

      // Only allow superadmin, admin or almighty
      if (claims.superadmin || claims.admin || claims.almighty) {
        dispatch(
          loginUserSuccess(
            response.user.toJSON(),
            true,
            idToken,
            response.user                   // userGetToken
          )
        );
      } else {
        const err = new Error(
          "No tienes acceso a este administrador. Contacta a soporte para más información"
        );
        dispatch(loginUserFailure(err));
        setFieldError("user", err.message);
      }
    } catch (error) {
      dispatch(loginUserFailure(error));
      setFieldError("user", error.message);
      console.error(error);
    }
  };
};

export const logoutUser = () => {
  return async (dispatch) => {
    dispatch(logoutUserStart());
    try {
      await auth.signOut();
      dispatch(logoutUserSuccess());
    } catch (error) {
      dispatch(logoutUserFailure(error));
      console.error(error);
    }
  };
};

export const loginUserStart = () => ({
  type: types.loginStart,
  payload: true,
});

export const loginUserSuccess = (user, loggedIn, idToken, userGetToken) => ({
  type: types.login,
  payload: {
    user: user,
    loggedIn: loggedIn,
    idToken: idToken,
    isLoadingAuth: false,
    userGetToken: userGetToken,
  },
});

export const loginUserFailure = (error) => ({
  type: types.loginFailure,
  payload: error,
});

export const logoutUserStart = () => ({
  type: types.logoutStart,
});

export const logoutUserSuccess = (user) => ({
  type: types.logoutSuccess,
});

export const logoutUserFailure = (error) => ({
  type: types.logoutError,
  payload: error,
});

export const signInWithEmail = (user, claims) => ({
  type: types.login,
  payload: {
    user,
    loggedIn: true,
    isAlmighty: claims.almighty,
    isSuperAdmin: claims.superadmin,
    isAdmin: claims.admin,
    isModerator: claims.moderator,
  },
});
export const setIsLoadingAuth = (isLoading) => ({
  type: types.isLoadingAuth,
  payload: {
    isLoadingAuth: isLoading,
  },
});

export const logout = () => ({
  type: types.logout,
  payload: {},
});
